module.exports = __webpack_public_path__ + "img/homeequity.8db57002.svg";